export default {
    path: '/salary_detail',
    meta: {
        title: '工资条',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/salary_detail`),
}


// WEBPACK FOOTER //
// ./src/views/SalaryDetail/router.js